import React, { Component } from "react";
import { Line } from "react-chartjs-2";

import Dropdown from "../dropdown";

import styles from "./line-chart.scss";

class LineChart extends Component {
  state = {
    options: [
      {
        id: 1,
        name: "Last 7 days",
      },
      {
        id: 2,
        name: "Last 30 days",
      },
      {
        id: 3,
        name: "Last 90 days",
      },
      {
        id: 4,
        name: "All",
      },
    ],
  };

  handleSortChange = (item) => {
    this.props.handleChange(item.name);
  };

  render() {
    const {
      data,
      title,
      selected,
      tooltipCallback,
      yAxesCallback,
    } = this.props;
    const { options } = this.state;
    const { labels } = data;

    // Prepare datasets for Chart.js v4 (immutable approach)
    const chartData = {
      ...data,
      datasets: data.datasets.map((dataset) => ({
        ...dataset,
        fill: false,
        tension: 0.2, // v4 uses 'tension' instead of 'lineTension'
      })),
    };

    // Chart.js v4 options
    const optionsLine = {
      responsive: true,
      maintainAspectRatio: true,
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            callback: yAxesCallback || ((value) => value),
          },
        },
        x: {
          display: true,
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: tooltipCallback ? {
          callbacks: {
            label: tooltipCallback,
          },
        } : {},
      },
    };

    const chart =
      labels.length !== 0 ? (
        <Line data={chartData} options={optionsLine} />
      ) : null;
    const empty = !chart ? <div className={styles.empty}></div> : null;

    return (
      <div className={styles.wrapper}>
        <div className={styles.titleCont}>
          <p className={styles.title}>{title}</p>
          <div className={styles.dropdownCont}>
            <Dropdown
              size="small"
              trim={80}
              options={options}
              value={selected}
              handleSelect={this.handleSortChange}
            />
          </div>
        </div>
        {chart}
        {empty}
      </div>
    );
  }
}

export default LineChart;
